$(".extra-q-input").on("input", function () {
  if (this.value.length > 0) {
    $(".extra-q-submit").addClass("active");
  } else {
    $(".extra-q-submit").removeClass("active");
  }
});
//submit extra question
$(".extra-q-submit").on("click", function () {
  $(".extra-q").addClass("hidden");
  $(".confirmation-message").removeClass("hidden");
  updateResponse(recordId, extra_q, $(".extra-q-input").val());
});

// Get the current URL
const url = new URL(window.location.href);

// Get the search parameters from the URL
const vars = new URLSearchParams(url.search);

// Access individual parameters
const email = vars.get("email");
const question = vars.get("question").replace(/_/g, " ");
let extra_q = "";
const response = vars.get("response").replace(/_/g, " ");
const date = vars.get("date").replace(/_/g, " ");
const extra_q_response = "";
if (vars.has("extra-q")) {
  extra_q = vars.get("extra-q").replace(/_/g, " ");

  $(".extra-q-text").html(extra_q);
  sendResponse(email, question, extra_q, response, extra_q_response);
} else {
  $(".extra-q").addClass("hidden");
  $(".confirmation-message").removeClass("hidden");
  sendResponse(email, question, extra_q, response, extra_q_response);
}

// Print the parameter values

let recordId = "";

function sendResponse(email, question, extra_q, response, extra_q_response) {
  data = {
    email: email,
    question: question,
    extra_q: extra_q,
    response: response,
    extra_q_response: extra_q_response,
    date: date,
  };
  $.ajax({
    type: "POST",
    url: "https://hook.us1.make.com/7t3h285lpp2vs5b8qlbd2gmwx88li73a",
    data: JSON.stringify(data),
    contentType: "application/json",
    success: function (data) {
        response = JSON.parse(data);
      recordId = response.recordId;
      console.log(recordId);
    },
    error: function (err) {
      console.log(err);
    },
  });
}

function updateResponse(recordId, extra_q, extra_q_response) {
  console.log(recordId);
  data = {
    recordId: recordId,
    date: date,
    extra_q: extra_q,
    extra_q_response: extra_q_response,
  };
  $.ajax({
    type: "POST",
    url: "https://hook.us1.make.com/7t3h285lpp2vs5b8qlbd2gmwx88li73a",
    data: JSON.stringify(data),
    contentType: "application/json",
    success: function (data) {
      console.log("success");
    },
    error: function (err) {
      console.log(err);
    },
  });
}
